var render = function render(){var _vm=this,_c=_vm._self._c;return (_vm.integrationSelected)?_c('div',[_c(_vm.integrationSelected.component,{tag:"div",staticClass:"mt-10"})],1):_c('page404')
}
var staticRenderFns = []

export { render, staticRenderFns }